import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      margin: 'auto',
      maxWidth: 800,
      color: 'black',
      textAlign: 'left',
      ['@media (max-width: 768px)']: {
        maxWidth: 400,
      },
    },
    amDoctorLink: {
      display: 'flex',
      marginLeft: 16,
      alignItems: 'center',
      marginTop: 16,
      marginBottom: 16,
      ['@media (max-width: 768px)']: {
        margin: 6,
      },
    },
    amDoctorText: {
      opacity: 0.65,
      letterSpacing: 0.1,
      fontWeight: 50,
      ['@media (max-width: 768px)']: {
        fontSize: 8,
      },
      ['@media (max-width: 340px)']: {
        fontSize: 6,
      },
    },
    arrow: {
      minWidth: 30,
      padding: [0, 5],
      justifySelf: 'center',
      alignSelf: 'center',
      ['@media (max-width: 768px)']: {
        minWidth: 10,
      },
    },
    buttonOld: {
      width: '25%',
      padding: [10, 14],
      color: 'white',
      background: '#009ACE',
      margin: ['12px', '18px', '12px', 'auto'],
      textAlign: 'center',
      ['@media (max-width: 768px)']: {
        fontSize: '0.5rem',
        margin: ['4px', '6px', '6px', 'auto'],
        padding: [6, 8],
      },
      ['@media (max-width: 340px)']: {
        fontSize: 6,
      },
    },
    buttonNew: {
      width: '80%',
      borderRadius: 5,
      padding: [10, 14],
      color: 'white',
      background: '#009ACE',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 6,
      marginBottom: 24,
      textAlign: 'center',
      ['@media (max-width: 768px)']: {
        fontSize: '0.5rem',
        padding: [6, 8],
      },
      ['@media (max-width: 340px)']: {
        fontSize: 6,
      },
    },
    chevron: {
      height: 24,
      width: 24,
      background: '#009ACE',
      borderRadius: '50%',
      marginRight: 12,
      display: 'flex',
      alignItems: 'center',
      ['@media (max-width: 768px)']: {
        height: 12,
        width: 12,
        marginRight: 4,
      },
    },
    chevronIcon: {
      color: 'white',
      height: '15px !important',
      ['@media (max-width: 768px)']: {
        height: '8px !important',
      },
      ['@media (max-width: 340px)']: {
        height: '6px !important',
      },
    },
    fadedText: { color: 'grey' },
    forgotLinkOld: {
      color: '#009ACE',
      marginLeft: 16,
      fontSize: 14,
      ['@media (max-width: 768px)']: {
        fontSize: 6,
        marginLeft: 6,
      },
    },
    forgotLinkNew: {
      color: '#009ACE',
      marginLeft: 24,
      fontSize: 14,
      marginBottom: 16,
      ['@media (max-width: 768px)']: {
        fontSize: 6,
        marginLeft: 6,
        marginBottom: 8,
      },
    },
    inputOld: {
      marginBottom: 10,
      ['@media (max-width: 768px)']: {
        marginBottom: 4,
      },
    },
    logo: {
      width: '150px !important',
      marginLeft: 'auto',
      paddingTop: 10,
      paddingRight: 10,
      ['@media (max-width: 768px)']: {
        width: '50px !important',
      },
      ['@media (max-width: 340px)']: {
        padding: [6, 6],
      },
    },
    widget: {
      transition: 'all 0.3s',
      alignSelf: 'center',
      width: '50%',
      height: 'fit-content',
      background: '#fff',
      borderRadius: '6px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
      border: 'none',
      zIndex: 0,
    },
    widgetNew: {
      background: '#fff',
    },
    widgetOld: {
      background: '#E6E5E5',
      boxShadow: 'none',
    },
    header: {
      textAlign: 'center',
      paddingTop: 20,
    },
    headerOld: {
      paddingTop: 5,
    },
    textFieldNew: {
      marginBottom: 16,
      ['@media (max-width: 768px)']: {
        marginBottom: 6,
      },
    },

    title: {
      fontWeight: 450,
      paddingTop: 35,
      marginBottom: 32,
      fontSize: '1.5em',
      textAlign: 'center',
      ['@media (max-width: 768px)']: {
        fontSize: '14px',
        paddingTop: 6,
        marginBottom: 10,
      },
      ['@media (max-width: 340px)']: {
        fontSize: 8,
        paddingTop: 0,
        marginBottom: 6,
      },
    },
    titleOld: {
      fontWeight: 150,
      paddingLeft: 10,
      fontSize: '1.25em',
      textAlign: 'left',
      maxWidth: '60%',
      marginBottom: 12,
      ['@media (max-width: 768px)']: {
        fontSize: '8px',
        paddingLeft: 4,
        marginBottom: 6,
      },
      ['@media (max-width: 340px)']: {
        fontSize: 7,
        marginLeft: 0,
      },
    },
    description: {
      textAlign: 'center',
      marginTop: 4,
      marginBottom: 32,
      color: 'rgba(0, 0, 0, 0.55)',
      ['@media (max-width: 768px)']: {
        fontSize: '0.5rem',
        marginBottom: 12,
      },
      ['@media (max-width: 340px)']: {
        fontSize: 6,
      },
    },
  },
  {
    name: 'Auth0MockStaticLoginInstructions',
  },
);
